// Share capability detection.
//
// P0-Fix 2026-07-15 ("Share-Button am Laptop tot"): `navigator.share()`
// on DESKTOP is notoriously unreliable — on Windows the OS share flyout
// sometimes never appears and the promise never settles (Chromium bugs
// 1050318 et al.), on Linux the API is missing entirely. Industry
// standard: use the native sheet ONLY on touch/mobile devices where it
// is reliable; desktop always gets the in-app share dialog
// (deterministic, instant, styleable).
export function canUseNativeShare() {
  if (typeof navigator === "undefined" || !navigator.share) return false;
  const touch = (navigator.maxTouchPoints || 0) > 0;
  const mobileUA = /Android|iPhone|iPad|iPod|Mobile/i.test(
    navigator.userAgent || "",
  );
  return touch && mobileUA;
}
